import React from 'react';
import c from 'classnames';

import {
  Icon,
  Image,
  useWindowDimensions,
} from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink } from '@uncinc/react-drupal-core';
import { SCREEN_NORMAL, SCREEN_WIDE } from '../../../config/constants';
import useBubble from '../../../helpers/useBubble';

import './style.scss';

type Props = {
  title: string,
  subtitle?: string,
  link: string,
  labelLinkTitle: string,
  imageUrl: string[],
  titleClassName?: string,
};

const LinkListPrimaryItem: React.FC<Props> = (props) => {
  const {
    title,
    subtitle,
    link,
    imageUrl,
    labelLinkTitle,
    titleClassName,
  } = props;

  const titleClasses = c('LinkListItem__title', titleClassName);
  const classes = c('LinkListItem');
  const { width } = useWindowDimensions();
  const isTablet = width < SCREEN_NORMAL;
  const isNormal = width < SCREEN_WIDE;

  const {
    BubbleComponent,
    parentRef,
    onEnter,
    onLeave,
  } = useBubble();

  // @ts-ignore
  const enter = (event) => {
    onEnter(event);
  };

  // @ts-ignore
  const leave = (event) => {
    onLeave(event);
  };

  return (
    <li
      // @ts-ignore
      ref={parentRef}
      className={classes}
      onMouseEnter={enter}
      onMouseLeave={leave}
      onFocus={enter}
      onBlur={leave}
    >
      <CoreLink href={link} title={title} className="LinkListItem__link">
        {!isTablet && (<BubbleComponent />)}

        <div className="LinkListItem__image">
          <Image src={imageUrl} alt={title} lazyload={false} />
        </div>

        <div className="LinkListItem__content">
          {isNormal ? (
            <>
              <div className={titleClasses}>
                <Icon name="format_quote" />
                {title}
              </div>
              <div className="LinkListItem__label">
                {/* @ts-ignore */}
                <CoreLink className="LinkListItem__label__link" href={link} tabIndex={-1}>{labelLinkTitle}<Icon name="arrow_forward" /></CoreLink>
              </div>
            </>

          ) : (
            <>
              <div className={titleClasses}>
                <Icon name="format_quote" />
                {title}
              </div>
              <div className="LinkListItem__subtitle">
                <span className="LinkListItem__subtitle__text">{subtitle}</span>
                <div className="LinkListItem__label">
                  {/* @ts-ignore */}
                  <CoreLink className="LinkListItem__label__link" href={link} tabIndex={-1}>{labelLinkTitle}<Icon name="arrow_forward" /></CoreLink>
                </div>
              </div>
            </>
          )}
        </div>
      </CoreLink>
    </li>
  );
};

export default LinkListPrimaryItem;
